var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('Tabs',[_c('Tab',{attrs:{"title":"NHVR"}},[_c('NHVRBreachesReport')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }